export const CarouselRightArrowIcon = () => {
    return (
        <svg xmlns="http://www.w3.org/2000/svg" width="24" height="27" viewBox="0 0 24 27" fill="none">
            <g filter="url(#filter0_d_8062_19852)">
                <path fillRule="evenodd" clipRule="evenodd"
                      d="M9.41421 20.418L8 19.0038L15.2948 11.7089L8 4.41406L9.41421 2.99985L18.1233 11.7089L9.41421 20.418Z"
                      fill="#FCFCFC"/>
            </g>
            <defs>
                <filter id="filter0_d_8062_19852" x="4" y="1" width="18.123" height="25.418"
                        filterUnits="userSpaceOnUse" colorInterpolationFilters="sRGB">
                    <feFlood floodOpacity="0" result="BackgroundImageFix"/>
                    <feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
                                   result="hardAlpha"/>
                    <feOffset dy="2"/>
                    <feGaussianBlur stdDeviation="2"/>
                    <feComposite in2="hardAlpha" operator="out"/>
                    <feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.4 0"/>
                    <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_8062_19852"/>
                    <feBlend mode="normal" in="SourceGraphic" in2="effect1_dropShadow_8062_19852" result="shape"/>
                </filter>
            </defs>
        </svg>
    );
};
